import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=af26e210&shadow"
import script from "./Panel.vue?vue&type=script&lang=js&shadow"
export * from "./Panel.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports